export default __webpack_public_path__ + "static/csvExport-4d7e26b044d856898ca3de864eaeeef1.gif";